"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionsList = exports.Suggestion = exports.SearchInput = exports.SearchContainer = exports.LocationSearchIcon = exports.LocationSearchButton = exports.Hr = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const searchIconGray_svg_1 = __importDefault(require("../../../assets/icons/searchIconGray.svg"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const Suggestion = styled_components_1.default.li `
  cursor: pointer;
  padding: 0.5rem;
  font-size: 1.6rem;
`;
exports.Suggestion = Suggestion;
const SuggestionsList = styled_components_1.default.ul `
  background-color: ${(p) => (p.$displaySearchResults ? `${colors_1.white}` : `none`)};
  position: absolute;
  top: 20%;
  list-style: none;
  left: 0;
  border: none;
  border-radius: 20px;
  box-shadow: ${(p) => p.$displaySearchResults ? `2px 2px 4px 0px rgba(76, 86, 96, 0.1)` : `none`};
  padding: 30px 0 8px 8px;
  width: 19rem;
  z-index: 2;
  color: ${colors_1.gray400};

  @media ${media_1.media.smallMobile} {
    width: 20rem;
  }

  @media ${media_1.media.smallDesktop} {
    width: 26rem;
  }

  @media ${media_1.media.mediumDesktop} {
    padding: 10px 0 8px 8px;
    border-radius: 0px 0px 10px 10px;
    top: 100%;
    z-index: 1;
  }
  @media ${media_1.media.largeDesktop} {
    width: 36.8rem;
  }
`;
exports.SuggestionsList = SuggestionsList;
const SearchInput = styled_components_1.default.input `
  width: 19rem;
  height: 3.2rem;
  border-radius: ${(p) => p.$displaySearchResults ? `15px 15px 0px 0px` : `20px`};
  border: none;
  box-shadow: ${(p) => p.$displaySearchResults
    ? `0px 2px 0px 0px rgba(76, 86, 96, 0.1)`
    : `2px 2px 4px 0px rgba(76, 86, 96, 0.1)`};
  background: ${colors_1.white} url(${searchIconGray_svg_1.default}) 12px center no-repeat;
  background-size: 16px;
  font-size: 1.6rem;
  padding-left: 3.8rem;
  outline: none;
  z-index: 3;
  color: ${colors_1.gray400};

  @media ${media_1.media.smallMobile} {
    width: 20rem;
  }

  @media ${media_1.media.smallDesktop} {
    width: 26rem;
  }

  @media ${media_1.media.mediumDesktop} {
    height: 4.2rem;
    font-size: 1.6rem;
    padding: 0 1.6rem;
    border-radius: 50px;
    border: ${(p) => p.$displaySearchResults ? `none` : `1px solid ${colors_1.gray500}`};
    background: ${colors_1.white} url(${searchIconGray_svg_1.default}) 16px center no-repeat;
    background-size: 20px;
    padding-left: 4.8rem;
    box-shadow: none;
  }

  @media ${media_1.media.largeDesktop} {
    width: 36.8rem;
  }
`;
exports.SearchInput = SearchInput;
const LocationSearchButton = styled_components_1.default.button `
  background-color: ${colors_1.white};
  height: 4rem;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  z-index: 2;

  @media ${media_1.media.mediumDesktop} {
    height: 4.2rem;
    background-color: transparent;
  }
`;
exports.LocationSearchButton = LocationSearchButton;
const LocationSearchIcon = styled_components_1.default.img `
  width: 4rem;
  height: 4rem;

  @media ${media_1.media.mediumDesktop} {
    width: 4.2rem;
    height: 4.2rem;
  }
`;
exports.LocationSearchIcon = LocationSearchIcon;
const SearchContainer = styled_components_1.default.div `
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 70vw;

  @media ${media_1.media.smallMobile} {
    gap: 1rem;
  }

  @media ${media_1.media.smallDesktop} {
    width: auto;
  }

  ${(props) => props.$isTimelapseView &&
    `opacity: 0.7;
    pointer-events: none;`}
`;
exports.SearchContainer = SearchContainer;
const Hr = styled_components_1.default.hr `
  visibility: hidden;

  @media ${media_1.media.mediumDesktop} {
    visibility: ${(p) => (p.$displaySearchResults ? `visible` : `hidden`)};
    border-top: 1px solid ${colors_1.gray500};
    width: 97%;
  }
`;
exports.Hr = Hr;
